module.exports = __webpack_public_path__ + "media/music/saw_lead_1-4decbdd9.mp3";